import {
  Progress as ChakraProgress,
  ProgressRoot,
  type ProgressRootProps
} from "@chakra-ui/react";
import { forwardRef } from "react";

import { asSlotComponent } from "../internal/v3-slot";

const ProgressTrack = asSlotComponent(ChakraProgress.Track);
const ProgressRange = asSlotComponent(ChakraProgress.Range);
const ProgressLabel = asSlotComponent(ChakraProgress.Label);
const ProgressValueText = asSlotComponent(ChakraProgress.ValueText);

export type ProgressProps = Omit<ProgressRootProps, "size"> & {
  size?:
    | ProgressRootProps["size"]
    | string
    | readonly string[]
    | Record<string, string | undefined>;
  indeterminate?: boolean;
  value?: number;
};

const Progress = forwardRef<HTMLDivElement, ProgressProps>(function Progress(
  {
    value,
    min = 0,
    max = 100,
    size,
    variant,
    colorPalette = "blue",
    indeterminate,
    children,
    ...props
  },
  ref
) {
  return (
    <ProgressRoot
      ref={ref}
      value={indeterminate ? null : value}
      min={min}
      max={max}
      size={size as ProgressRootProps["size"]}
      variant={variant}
      colorPalette={colorPalette}
      {...props}
    >
      <ProgressTrack>
        <ProgressRange />
      </ProgressTrack>
      {children}
    </ProgressRoot>
  );
});

export { Progress, ProgressLabel, ProgressValueText };
